// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__aup+f","dark":"BaseLayout_dark__zYIcA","light":"BaseLayout_light__sr59t"};